import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amazon-inspection',
  templateUrl: './amazon-inspection.component.html',
  styleUrls: ['./amazon-inspection.component.css'],
})
export class AmazonInspectionComponent implements OnInit {
  protected tab = 0;
  constructor() {}

  ngOnInit(): void {}

  changeTab($event: any) {
    this.tab = $event.index;
  }
}
